const lastUpdate = '2024-12-12';

export const helpTitle = 'Map Print Tool Help';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The Map Print Tool allows you to capture the current view of the map, add a border and scale, and export it as an image or PDF. You can also print the captured map directly from your browser.</p>

<h2>How to Use</h2>

<ol>
  <li><strong>Capture the Map:</strong>
    <ul>
      <li>Click the <i class="fas fa-print"></i> icon to capture the current view of the map.</li>
      <li>The tool will capture the map, add a border and scale, and open the captured image in a new tab.</li>
    </ul>
  </li>
  <li><strong>View and Save the Captured Map:</strong>
    <ul>
      <li>The captured map will be displayed in a new tab with options to copy, save, or print the image.</li>
      <li>Click the "Download PDF" button to save the captured map as a PDF file.</li>
      <li>You can also use the browser's print functionality (Ctrl + P on Windows or Cmd + P on Mac) to print the captured map.</li>
    </ul>
  </li>
</ol>

<h2>Additional Information</h2>
<p>The captured map includes a border and scale to provide context for the measurements. The scale is calculated based on the current zoom level of the map.</p>

<p>For further assistance, please refer to the documentation or contact support.</p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;